import { AiOutlineDownload } from "react-icons/ai"
import { Collapse } from 'antd';
import { useAuth } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import useFaq from "./useFaq";
import { useEffect } from "react";
import ActionButtonGradient from "../../../components/button/ActionButtonGradient";

const Faq = () => {
    const {getCurrentRole} = useAuth()
    const role = getCurrentRole()
    const navigate = useNavigate()
    const {
        payload,
        getActiveHomepage
    } = useFaq()

    useEffect(() => {
        getActiveHomepage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const downloadFaqEnglish = () => {
        window.open('https://drive.google.com/file/d/16nEtWN724C1_UymlrrHHk4I1v4SLBRdZ/view?usp=sharing', '_blank', 'noopener,noreferrer');
    };

    const downloadFaqIndonesia = () => {
        window.open('https://drive.google.com/file/d/1WKEuCgk17DwwQv52aQcHFkSv6iQuMlvR/view?usp=sharing', '_blank', 'noopener,noreferrer');
    };

    // const downloadBulkUpload = () => {
    //     window.location.href = 'https://docs.google.com/spreadsheets/d/1PAl_Rzoc0CckN8X3IT8Mzjdw35MSr4G1dI9vuVpQCfU/export?format=xlsx';
    // };
    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            {/* Download Section */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Calibration Guidelines
                    </h5>
                </div>
                
                <p style={{ 
                    fontSize: '14px', 
                    color: '#6c757d',
                    marginBottom: '16px'
                }}>
                    Download calibration guide
                </p>

                <div className="d-flex gap-3 flex-wrap">
                    <ActionButtonGradient
                        onClick={() => downloadFaqIndonesia()}
                        variant="primary"
                        children={<><AiOutlineDownload fontSize={16}/> Calibration Guideline (Indonesia)</>}
                    />
                    <ActionButtonGradient
                        onClick={() => downloadFaqEnglish()}
                        variant="primary"
                        children={<><AiOutlineDownload fontSize={16}/> Calibration Guideline (English)</>}
                    />
                </div>
            </div>

            {/* FAQ Section */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Frequently Asked Questions
                    </h5>
                    {
                        role && (role.includes("superadmin") || role.includes("admin")) && (
                            <ActionButtonGradient
                                onClick={() => navigate("list")}
                                variant="success"
                                children={"Edit FAQ"}
                            />
                        )
                    }
                </div>

                <p style={{ 
                    fontSize: '14px', 
                    color: '#6c757d',
                    marginBottom: '16px'
                }}>
                    Have questions? We're here to help
                </p>

                <Collapse 
                    defaultActiveKey={[0]} 
                    items={payload}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none'
                    }}
                />
            </div>
        </div>
    )
}

export default Faq